import axios from 'axios';
import baseConfig from './config';

let pending = []; //声明一个数组用于存储每个请求的取消函数和axios标识
let cancelToken = axios.CancelToken;
let removePending = (config) => {
  for(let p in pending){
    if(pending[p].u === config.url + JSON.stringify(config.data) +'&' + config.method) { //当前请求在数组中存在时执行函数体
      if(config.url.indexOf('prPluginList/getIprPluginListList')!=-1){
        //想取消重复请求↑↑
        pending[p].f(); //执行取消操作
      }
      pending.splice(p, 1);
    }
  }
}
// 退出登录
function goLogin() {
  localStorage.removeItem("token");
  sessionStorage.removeItem("token");
  // 刷新页面
  location.reload();
}

// 根据服务名生成方法
function getHttpFetch(service_name, ip) {
  if (ip) baseConfig.baseURL = ip;
  baseConfig.baseURL += service_name;

  const httpFetch = axios.create(baseConfig);

  // 请求拦截器
  httpFetch.interceptors.request.use(config => {
    if (localStorage.getItem('bmcKefuid')) {
      config.headers[ 'pageBmcid' ] = localStorage.getItem('bmcKefuid');
    }
    removePending(config); //在一个axios发送前执行一下取消操作
    config.cancelToken = new cancelToken((c)=>{
      // 这里的axios标识是用请求地址&请求方式拼接的字符串
      pending.push({ u: config.url + JSON.stringify(config.data) +'&' + config.method, f: c });//config.data为请求参数
    });
    return config;
  }, error => {
    Promise.reject(error);
  })

  // 响应拦截器
  httpFetch.interceptors.response.use((response) => {
		var data = response.data;

    removePending(response.config)
    if (response.config.noFormat) {
    }
    else {
      // 处理异常请求
      if (data.code == 400) {
        // this.$message.error('接口报错了哦！请联系管理员！');
        // console.log(data.message);
        // 请求越权
        if (data.data.errorCode == "10211") {
        } else {
          goLogin();
        }
      }
      else if (data.code != 200) {
        // this.$message.error('接口报错了哦！请联系管理员！');
        // console.log(data.message);
        // console.log(response);
      }
    }
    return data;
  }, (error) => {
    // 检测登录状态（网络错误时 error.response 可能为 undefined，需判空）
    if (error.response && error.response.status == 503) {
      window.location.href=window.location.host + '/#/login'
      goLogin();
    }
    // 关键修复：必须 return Promise.reject(error)，
    // 否则 axios 会认为错误已被处理，promise 链 resolve 成 undefined，
    // 下游拿到的不是错误对象而是 undefined（表现为"接口无响应"）
    return Promise.reject(error);
  });

  return httpFetch;
}

export default getHttpFetch;
